/* eslint-disable jsdoc/require-jsdoc */
import { ReactElement, MutableRefObject } from 'react';
import DataWidget from '../../components/DataWidget';
import DashboardCharts from '../../components/DashboardCharts';
import InsightsWidget from '../../components/InsightsWidget';
import FloorMapCarouselWidget from '../../components/FloormapCarouselWidget';
import ActivitiesWidget from '../../components/activities.widget';
import DeviceListWidget from '../../components/devices/DeviceListWidget';
import {
  DataWidgetMinMaxAttribute,
  DashboardDataFilter,
  TimeSpan,
  TimeSpanDateAttributes,
  ParametersType,
  Group
} from '../../constants/telosair-interfaces';
import Deque from '../../classes/deque';
import { useUnifiedData } from '../../hooks/useUnifiedData';
import { deviceFilterWithDeviceType } from '../../_helpers/globalHelper';

interface DetailedPageProps {
  minMaxData: DataWidgetMinMaxAttribute | null;
  setSidePanelParameter: (
    param: { serialNumber: number; parameter: ParametersType } | null
  ) => void;
  dataFilter: DashboardDataFilter | null;
  extendedLabel: string;
  groupedData: Group[];
  setDataFilter?: (filter: DashboardDataFilter | null) => void;
  timeSpan: TimeSpan;
  timeSpanDate: TimeSpanDateAttributes | null;
  loading: boolean;
  chartQueueDataRef: MutableRefObject<Record<ParametersType, Deque>>;
  setSelectedParameter: (param: ParametersType[] | null) => void;
  devicesLoading: boolean;
}

export default function DetailedPage({
  minMaxData,
  setSidePanelParameter,
  dataFilter,
  extendedLabel,
  groupedData,
  setDataFilter,
  timeSpan,
  timeSpanDate,
  loading,
  chartQueueDataRef,
  setSelectedParameter,
  devicesLoading
}: DetailedPageProps): ReactElement {
  const { devices, groupTypes } = useUnifiedData();
  const type = deviceFilterWithDeviceType(dataFilter, devices, groupTypes);
  return (
    <>
      <div className="flex flex-1 w-full">
        <div className="grid grid-cols-1 md:grid-cols-9 gap-4 w-full">
          <div className="col-span-1 md:col-span-3 rounded-lg mb-0 flex flex-1 h-[300px] md:h-auto">
            <DataWidget
              minMaxData={minMaxData}
              onClick={(parameter, serialNumber) =>
                setSidePanelParameter({ serialNumber, parameter })
              }
              dataFilter={dataFilter}
              extendedLabel={extendedLabel}
            />
          </div>
          <div className="col-span-1 md:col-span-3 rounded-lg flex flex-1 flex-col h-[300px] md:h-auto">
            <FloorMapCarouselWidget
              dataFilter={dataFilter}
              setDataFilter={setDataFilter}
              loading={devicesLoading}
              extendedLabel={extendedLabel}
              groups={groupedData}
            />
          </div>
          <div className="col-span-1 md:col-span-3 flex flex-1 flex-col h-[300px] md:h-auto">
            <ActivitiesWidget extendedLabel={extendedLabel} dataFilter={dataFilter} />
          </div>
        </div>
      </div>
      <div className="flex flex-1 w-full">
        {timeSpanDate && (
          <div className="grid grid-cols-1 md:grid-cols-9 w-full gap-4 ">
            <div className="col-span-1 md:col-span-3 flex flex-1 h-[300px] md:h-auto">
              {timeSpanDate && (
                <DeviceListWidget
                  setDataFilter={setDataFilter}
                  loading={loading}
                  dataFilter={dataFilter}
                  extendedLabel={extendedLabel}
                />
              )}
            </div>
            <div className="col-span-1 md:col-span-3 h-[300px] md:h-auto">
              <div className="h-full">
                {timeSpanDate && (
                  <DashboardCharts
                    extendedLabel={extendedLabel}
                    loading={loading}
                    lineChartGraphData={chartQueueDataRef.current}
                    timeSpan={timeSpan}
                    onChangeParameter={setSelectedParameter}
                    expanded={false}
                    type={type}
                  />
                )}
              </div>
            </div>
            <div className="col-span-1 md:col-span-3 flex flex-1 h-[300px] md:h-auto">
              <InsightsWidget />
              {/* <DashboardHeatmapWidget
                  data={transformDataForPlotByQueues(chartQueueDataRef.current)}
                  extendedLabel={extendedLabel}
                  timeSpan={timeSpan}
                  isDataLoading={loading}
                /> */}
            </div>
          </div>
        )}
      </div>
    </>
  );
}
